import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

import { notification } from 'antd';
import i18n from 'i18next';

notification.config({
	placement: 'topRight',
	top: 75,
	duration: 2,
});

// Done.
const createProject = async (modelId, viewId, newProject) => {
	try {
		const api = await getAPI();
		const { data } = await api.post(`model/${modelId}/view/${viewId}/project/new`, newProject);

		notification.success({
			message: 'Project Created',
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.log(error.response);
	}
};

// Done.
const getAllProjectsOfView = async (modelId, viewId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/view/${viewId}/project/all`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
};

// Get all Projects for Kanban Board
const getAllProjectsForKanbanBoard = async (modelId, viewId, layoutId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/view/${viewId}/project/kanban/layout/${layoutId}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
}

// Done.
const getProject = async (modelId, viewId, projectId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/view/${viewId}/project/${projectId}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
};

const updateProject = async (modelId, viewId, projectId, projectUpdates) => {
	try {
		const api = await getAPI();
		const { data } = await api.put(`model/${modelId}/view/${viewId}/project/${projectId}`, { projectUpdates });
		notification.success({
			message: i18n.t('project.note-project-edited', 'project updated'),
			description: i18n.t(''),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('project.note-project-edit-error', 'project  could not be updated'),
			description: error.message,
		});
		console.log(error.response);
	}
};

const deleteProject = async (modelId, viewId, projectId) => {
	try {
		const api = await getAPI();
		const { data } = await api.delete(`model/${modelId}/view/${viewId}/project/${projectId}`);
		notification.success({
			message: i18n.t('project.note-project-deleted', 'project deleted'),
			description: i18n.t(''),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('project.note-project-delete-error', 'project could not be deleted'),
			description: error.message,
		});
		console.log(error.response);
	}
};

const getProjectLog = async (modelId, projectId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/project/${projectId}/log`);
		if (data?.error) {
			throw data.error;
		}
		return data.csvString;
	} catch (error) {
		const errorString = error.response ? error.response : error;

		notification.error({
			message: 'Project Log Error',
			description: errorString,
		});

		return null;
	}
};

export { createProject, getAllProjectsOfView, deleteProject, updateProject, getProjectLog, getProject, getAllProjectsForKanbanBoard };
